/**
 * API Configuration
 * В production используем относительные пути (nginx проксирует на том же домене)
 * В development используем localhost:8000
 */

const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? '' // Production: относительные пути (https://solidityset.ru/api, /auth, etc)
  : 'http://localhost:8000'; // Development: прямое подключение к FastAPI

export default API_BASE_URL;
